import { IBusinessDocumentDocs } from '../utils';

// src/pages/onboarding/utils/businessDocumentsRequirements.ts
export const DOCUMENT_REQUIREMENTS: Record<string, Record<string, IBusinessDocumentDocs[]>> = {
  NG: {
    soleProprietorship: [{ name: 'taxDocument', label: 'Status Report or Form CAC/BN/1' }],
    partnership: [
      { name: 'taxDocument', label: 'Status Report or Form CAC/BN/1' },
      { name: 'partnershipAgreement', label: 'Partnership Agreement(Optional)', removeStrict: true }
    ],
    limitedLiability: [
      { name: 'memart', label: 'Memorandum and Articles of Association (MEMART)' },
      { name: 'boardResolution', label: 'Certificate of Incumbency/ Board Resolution' },
      { name: 'taxDocument', label: 'Status Report or Form CAC/BN/1' }
    ]
  },
  KE: {
    soleProprietorship: [{ name: 'taxDocument', label: 'Kenya Revenue Authority PIN Certificate' }],
    partnership: [
      { name: 'taxDocument', label: 'Kenya Revenue Authority PIN Certificate' },
      { name: 'partnershipAgreement', label: 'Partnership Agreement(Optional)', removeStrict: true }
    ],
    limitedLiability: [
      { name: 'memart', label: 'Memorandum and Articles of Association (MEMART)' },
      { name: 'taxDocument', label: 'Kenya Revenue Authority PIN Certificate' },
      { name: 'cR12', label: 'CR12' },
      { name: 'boardResolution', label: 'Certificate of Incumbency/ Board Resolution' }
    ]
  },
  GH: {
    soleProprietorship: [{ name: 'taxDocument', label: 'Form A' }],
    partnership: [
      { name: 'taxDocument', label: 'Form A' },
      { name: 'partnershipAgreement', label: 'Partnership Agreement(Optional)', removeStrict: true }
    ],
    limitedLiability: [
      { name: 'memart', label: 'Memorandum and Articles of Association (MEMART)' },
      { name: 'boardResolution', label: 'Certificate of Incumbency/ Board Resolution' },
      { name: 'taxDocument', label: 'Form A' }
    ]
  }
};
